let ctx;

export const unlockAudio = () => {
  ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
  if (ctx.state === "suspended") ctx.resume();
};

export const playTone = side => {
  if (!ctx) return;
  const notes = side === "BUY" ? [523, 659, 784, 1047] : [1047, 784, 659, 523];
  notes.forEach((freq, i) => {
    const osc = ctx.createOscillator(); const gain = ctx.createGain();
    const start = ctx.currentTime + i * 0.16;
    osc.type = "square"; osc.frequency.value = freq;
    gain.gain.setValueAtTime(0.0001, start);
    gain.gain.exponentialRampToValueAtTime(0.18, start + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.14);
    osc.connect(gain).connect(ctx.destination); osc.start(start); osc.stop(start + 0.15);
  });
};

export const speak = text => {
  if (!window.speechSynthesis) return;
  const u = new SpeechSynthesisUtterance(text);
  u.lang = "en-IN"; u.rate = 1;
  window.speechSynthesis.speak(u);
};

export const fireAlarm = (signal, symbol, { tone, voice }) => {
  if (tone) playTone(signal.type);
  if (voice) setTimeout(() => speak(`${signal.type === "BUY" ? "Buy" : "Sell"} ${symbol} at ${Math.round(signal.price)} rupees`), tone ? 750 : 0);
};
